export const expandableCollapsedDefaultHeight = 100;
export const expandableDefaultAnimationTime = 300;
